// Fenced code blocks (an unclosed fence runs to the end) and inline code spans.
const CODE_SEGMENT = /(```[\s\S]*?(?:```|$)|`[^`\n]*`)/g;

// A "<" that opens an HTML construct: a tag, closing tag, comment or
// processing instruction. A "<" followed by a space or digit (e.g. "a < b")
// cannot start markup and is left alone.
const TAG_OPEN = /<(?=[A-Za-z/!?])/g;

/**
 * Encode the opening "<" of HTML tags in chat input as "&lt;" so the text can
 * never be interpreted as markup by a downstream HTML renderer.
 *
 * Code blocks and inline code are left untouched so snippets such as
 * `List<String>` reach the agent unchanged. The operation is idempotent:
 * already-encoded text contains no "<" to encode.
 */
export function escapeChatQuery(query: string): string {
  return query
    .split(CODE_SEGMENT)
    .map((part, index) =>
      index % 2 === 1 ? part : part.replace(TAG_OPEN, "&lt;")
    )
    .join("");
}
